const WISHLIST_KEY = 'wishlist';

/* Get wishlist from localStorage */
let wishlistArray = JSON.parse(sessionStorage.getItem(WISHLIST_KEY)) || [];

const allWishHeadLink = document.querySelectorAll('.wishlist_link');

function updateWishlistHeader() {
  if (wishlistArray.length) {
    allWishHeadLink?.forEach(link => {
      link.classList.add('active');
      const bubble = link.querySelector('.wishlist-bubble');
      if (!bubble) return;
      bubble.classList.remove('hidden');
      bubble.innerText = wishlistArray.length;
    });
  } else {
    allWishHeadLink?.forEach(link => {
      link.classList.remove('active');
      const bubble = link.querySelector('.wishlist-bubble');
      if (!bubble) return;
      bubble.classList.add('hidden');
      bubble.innerText = '';
    });
  }
}

function saveWishlistToLocalStorage() {
  sessionStorage.setItem(WISHLIST_KEY, JSON.stringify(wishlistArray));
}

function onButtonClick(button) {
  const variantId = button.dataset.var;

  const exists = wishlistArray.find(obj => obj.var === variantId);

  if (!exists) {
    wishlistArray.push({
      id: button.dataset.id,
      title: button.dataset.title,
      handle: button.dataset.handle,
      var: variantId
    });
  } else {
    wishlistArray = wishlistArray.filter(obj => obj.var !== variantId);
  }

  document.querySelectorAll('wishlist-button').forEach(btn => {
    if (btn.dataset.var === variantId) {
      btn.classList.toggle('active', !exists);
    }
  });

  saveWishlistToLocalStorage();
  updateWishlistHeader();
}

class WishlistButton extends HTMLElement {
  connectedCallback() {
    this.addEventListener('click', () => onButtonClick(this));

    if (wishlistArray.find(obj => obj.var === this.dataset.var)) {
      this.classList.add('active');
    }
  }
}

customElements.define('wishlist-button', WishlistButton);

updateWishlistHeader();
